import { cn } from "@/lib/utils";
import { QuoteData } from "@/types/modules";
import { stripInlineMarkdown } from "@/utils/inline-markdown";
import { MODULE_LABEL_WRAP } from "./module-label-budget";
import { primaryToneVar } from "./module-accent";

interface ModuleQuoteProps {
  data: QuoteData;
  grayscale?: boolean;
  accent?: number;
  className?: string;
}

export default function ModuleQuote({ data, grayscale, accent, className }: ModuleQuoteProps) {
  const tone = primaryToneVar(grayscale, accent);
  const toneStyle = tone ? { color: tone } : undefined;
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <svg
        width="26"
        height="22"
        viewBox="0 0 26 22"
        className="text-primary"
        style={toneStyle}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="currentColor"
          d="M15.0662 22V14.3846C15.0662 10.6051 15.9272 7.41795 17.649 4.82308C19.4283 2.17179 22.2119 0.564102 26 0V4.4C23.7616 4.62564 22.2119 5.41538 21.351 6.76923C20.5475 8.06667 20.1457 10.0128 20.1457 12.6077L16.702 12.1H25.9139V22H15.0662ZM0 22V14.3846C0 10.6051 0.860927 7.41795 2.58278 4.82308C4.36203 2.17179 7.1457 0.564102 10.9338 0V4.4C8.69536 4.62564 7.1457 5.41538 6.28477 6.76923C5.48124 8.06667 5.07947 10.0128 5.07947 12.6077L1.63576 12.1H10.8477V22H0Z"
        />
      </svg>
      <h4 className={cn("text-lg leading-tight", MODULE_LABEL_WRAP.body)}>
        {stripInlineMarkdown(data.quote)}
      </h4>
      <div className="flex flex-row gap-2 items-start justify-between">
        <div className="flex flex-col">
          <p
            className={cn(
              "text-sm text-neutral-500 dark:text-neutral-400 font-medium",
              MODULE_LABEL_WRAP.row,
            )}
          >
            {stripInlineMarkdown(data.author)}
          </p>
          <p
            className={cn(
              "text-sm text-neutral-500 dark:text-neutral-400 italic",
              MODULE_LABEL_WRAP.row,
            )}
          >
            {stripInlineMarkdown(data.role)}
          </p>
        </div>
        <svg
          width="26"
          height="22"
          viewBox="0 0 26 22"
          className="text-primary"
          style={toneStyle}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M15.0662 22V14.3846C15.0662 10.6051 15.9272 7.41795 17.649 4.82308C19.4283 2.17179 22.2119 0.564102 26 0V4.4C23.7616 4.62564 22.2119 5.41538 21.351 6.76923C20.5475 8.06667 20.1457 10.0128 20.1457 12.6077L16.702 12.1H25.9139V22H15.0662ZM0 22V14.3846C0 10.6051 0.860927 7.41795 2.58278 4.82308C4.36203 2.17179 7.1457 0.564102 10.9338 0V4.4C8.69536 4.62564 7.1457 5.41538 6.28477 6.76923C5.48124 8.06667 5.07947 10.0128 5.07947 12.6077L1.63576 12.1H10.8477V22H0Z"
          />
        </svg>
      </div>
    </div>
  );
}
